var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgButtonIdKaartActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "68px",
    height: "15px",
    viewBox: "0 0 68 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "410F7BE3-FCE1-481B-B277-D03607315A7B_SVG") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Eraklient",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "UI-Framework",
    transform: "translate(-512.000000, -1091.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(480.000000, 1000.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9-Copy",
    transform: "translate(16.000000, 76.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Button_ID-Kaart_Active",
    transform: "translate(16.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.6035,10.7734 L12.2975,10.7734 L12.2825,4.2284 L13.6815,4.2284 C13.6815,4.2284 16.5875,3.9964 16.5875,7.4164 C16.5875,10.8354 13.6035,10.7734 13.6035,10.7734 M15.0955,0.2494 L9.1575,0.2494 C7.1355,0.2494 7.0735,1.8184 7.0735,2.1754 C7.0735,2.5344 7.0425,9.4834 7.0425,12.2824 C7.0425,14.9404 9.4675,14.7384 9.4675,14.7384 L14.7855,14.7384 C21.5325,14.7384 21.9675,9.4204 21.9675,7.9604 L21.9675,6.8394 C21.7345,1.0414 17.0075,0.2494 15.0955,0.2494",
    id: "Fill-39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,7.3691 L5.41,5.2231 L5.379,12.5181 C5.379,12.5181 5.457,15.0001 2.721,15.0001 C-0.016,15.0001 0.006,12.6891 0.006,12.6891 L0,7.3691 Z",
    id: "Fill-41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.4102,3.4521 L0.0002,5.5981 L0.0312,2.4811 C0.0312,2.4811 -0.0468,9.99999993e-05 2.6892,9.99999993e-05 C5.4262,9.99999993e-05 5.4042,2.3101 5.4042,2.3101 L5.4102,3.4521 Z",
    id: "Fill-43"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-45",
    points: "24.752 8.583 27.904 8.583 27.904 7.479 24.752 7.479"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-47",
    points: "31.5029 7.416 30.9269 7.416 30.9269 12.6 29.7279 12.6 29.7279 1.399 30.9269 1.399 30.9269 6.615 31.4869 6.392 34.3989 1.399 35.7749 1.399 32.8469 6.231 32.2869 6.743 32.9429 7.384 36.1909 12.6 34.6709 12.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.498,8.4238 L42.05,8.4238 L41.077,4.9458 L40.782,3.2558 L40.75,3.2558 L40.439,4.9788 L39.498,8.4238 Z M42.338,9.4638 L39.18,9.4638 L38.286,12.5998 L37.102,12.5998 L40.478,1.2238 L41.135,1.2238 L44.511,12.5998 L43.246,12.5998 L42.338,9.4638 Z",
    id: "Fill-48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6572,8.4238 L50.2092,8.4238 L49.2362,4.9458 L48.9412,3.2558 L48.9092,3.2558 L48.5982,4.9788 L47.6572,8.4238 Z M50.4972,9.4638 L47.3392,9.4638 L46.4452,12.5998 L45.2612,12.5998 L48.6372,1.2238 L49.2942,1.2238 L52.6702,12.5998 L51.4052,12.5998 L50.4972,9.4638 Z",
    id: "Fill-49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.0908,6.6797 L56.0508,6.6797 C56.6588,6.6797 57.1398,6.4927 57.4908,6.1187 C57.8428,5.7457 58.0198,5.1757 58.0198,4.4077 C58.0198,3.8217 57.8718,3.3357 57.5788,2.9507 C57.2858,2.5677 56.8518,2.3757 56.2758,2.3757 C56.0618,2.3757 55.8408,2.3837 55.6118,2.3997 C55.3818,2.4157 55.2078,2.4397 55.0908,2.4717 L55.0908,6.6797 Z M53.8918,1.5117 C54.2428,1.4267 54.6298,1.3657 55.0508,1.3267 C55.4728,1.2897 55.8598,1.2717 56.2108,1.2717 C56.6268,1.2717 57.0218,1.3227 57.3958,1.4237 C57.7688,1.5257 58.0938,1.6957 58.3708,1.9357 C58.6488,2.1757 58.8698,2.4907 59.0348,2.8797 C59.1998,3.2697 59.2828,3.7567 59.2828,4.3437 C59.2828,5.2297 59.0998,5.9387 58.7318,6.4717 C58.3628,7.0047 57.8748,7.3627 57.2678,7.5437 L57.8748,8.1357 L60.0828,12.5997 L58.6918,12.5997 L56.2908,7.7197 L55.0908,7.4797 L55.0908,12.5997 L53.8918,12.5997 L53.8918,1.5117 Z",
    id: "Fill-50"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-51",
    points: "67.2217 2.5039 64.4697 2.5039 64.4697 12.5999 63.2697 12.5999 63.2697 2.5039 60.5177 2.5039 60.5177 1.3999 67.2217 1.3999"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonIdKaartActive);
export default __webpack_public_path__ + "static/media/Button_ID-Kaart_Active.df65f933148c23bb0af163ba69d0bbfb.svg";
export { ForwardRef as ReactComponent };